import { Link } from "react-router-dom";
import { Palette, ArrowRight } from "lucide-react";
import { useFeaturedDesigns } from "@/hooks/useFeaturedDesigns";

export function DesignStudioSection() {
  const { items, loading } = useFeaturedDesigns();
  if (loading || items.length === 0) return null;

  return (
    <section
      data-testid="design-studio-section"
      className="border-t border-[#1A1A1A] py-16 sm:py-20"
      style={{ backgroundColor: "#050505" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Palette className="h-4 w-4 text-[#39FF14]" strokeWidth={1.5} />
              <p className="font-mono uppercase tracking-[0.3em] text-xs font-bold text-[#39FF14]">
                Design Studio
              </p>
            </div>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tighter text-[#F2F2F2] leading-[0.95]"
              style={{ fontFamily: "Chivo, sans-serif" }}
            >
              Built From<br />
              <span className="text-[#39FF14]">Your Imagination</span>
            </h2>
          </div>
          <Link
            to="/design-request"
            data-testid="design-studio-cta"
            className="inline-flex items-center gap-2 font-mono uppercase tracking-[0.15em] text-xs font-bold text-[#050505] bg-[#39FF14] hover:bg-[#4DFF2E] px-6 py-4 transition-colors self-start"
          >
            Design Your Own
            <ArrowRight className="h-3 w-3" />
          </Link>
        </div>

        <div className={`grid gap-3 ${items.length === 1 ? "grid-cols-1" : items.length === 2 ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 sm:grid-cols-3"}`}>
          {items.map((item) => {
            const hero = item.completion_image_urls?.[0];
            if (!hero) return null;
            return (
              <Link
                key={item.id}
                to="/design-request"
                data-testid={`design-studio-card-${item.id}`}
                className="group relative block bg-[#0D0D0D] border border-[#1A1A1A] hover:border-[#39FF14]/50 overflow-hidden transition-colors"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={hero}
                    alt={item.completion_caption || "Custom Xbox build"}
                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-[1.03] transition-all duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-transparent p-4 pt-16">
                  <p className="font-mono uppercase tracking-[0.2em] text-[10px] font-bold text-[#39FF14] mb-1">
                    Custom Build
                  </p>
                  <p className="text-[#F2F2F2] text-sm font-bold leading-tight line-clamp-2" style={{ fontFamily: "Chivo, sans-serif" }}>
                    {item.completion_caption || "One-of-a-kind original Xbox"}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
